import './index_web.css';

interface Props {
  onCancel?: any;
  isLandscape?: boolean;
  onPressTryAgain_?: any;
  timer?: any;
  isPlayerNotFound?: boolean;
}

const MatchMakingLoaderWeb = ({
  onCancel,
  isLandscape,
  onPressTryAgain_,
  timer,
  isPlayerNotFound
}: Props) => {
  return (
    <div
      className={`${
        isLandscape ? 'matchMakingLoader__landscape' : 'matchMakingLoader__container__web'
      }`}>
      <div
        className={`${isLandscape ? 'matchMaking__timer__landscape' : 'matchMaking__timer__web'}`}>
        <span
          className={`${
            isLandscape ? 'matchMaking__timerLabel__landscape' : 'matchMaking__timerLabel__web'
          }`}>
          {timer}
        </span>
      </div>

      {isPlayerNotFound ? (
        <>
          <div className="matchMaking__status__web">Player Not Found</div>
        </>
      ) : (
        <div className="matchMaking__status__web">Looking for players</div>
      )}

      <div
        className={`${
          isLandscape ? 'matchMaking__btnWrapper__landscape' : 'matchMaking__btnWrapper__web'
        }`}>
        {isPlayerNotFound ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row'
            }}>
            <button className={'matchmaking__tryAgainBtn__web'} onClick={onPressTryAgain_}>
              {'SEARCH AGAIN'}
            </button>
            <button className="matchMaking__cancelBtn__web" onClick={onCancel}>
              {'GO BACK'}
            </button>
          </div>
        ) : (
          <button className="matchMaking__cancelBtn__web" onClick={onCancel}>
            {'Cancel'}
          </button>
        )}
      </div>
    </div>
  );
};

export default MatchMakingLoaderWeb;
